enum NotificationFormType {
  expirationDate,
  isRecurring,
  scheduledDateTime,
  recurringDays,
  textDutch,
  textEnglish,
  invalidOfficeId,
  invalidTimeToSend,
  pastScheduledDateTime,
  expirationBeforeScheduled,
  invalidInitialScheduledDateTime,
}

export default NotificationFormType;
